/**
 *  API 模块，支持两种使用方式
 *      1、 在组件中，直接导入结构分模块
 *      2.利用挂载的全局变量来使用
 */
import api from "./module/apis.js"; // 项目简单时，api直接挂载到$api下

export let $api = {
  ...api,
};
// 提供 Vue.use 方式使用
// export default {
//   install(app, options) {
//     app.config.globalProperties.$api = $api;
//   },
// };

export default {
  install (vm) {
    vm.prototype.$api = $api
  }
}